<template>
  <div class="fixed left-0 right-0 z-modal w-full h-full top-0">
    <div class="flex flex-col h-full bg-zt-normal rounded-t-xl shadow-lg">
      <div class="bg-zt-normal">
        <div class="w-full py-4 px-5 flex justify-start items-center">
          <span class="font-semibold text-base">{{ title }}</span>
          <div class="x-close-modal" @click="$emit('closeModal')"></div>
        </div>
        <hr class="w-full border-zt-light">
      </div>
      <div class="overflow-auto">
        <div v-for="(option, index) of options"
             class="flex flex-col items-center bg-zt-normal rounded-b-xl w-full text-base">
          <div @click="handleOptionClick(option)"
               :class="{ 'selected' : selectedOption === option || selectedOption?.string === option }"
               class="option w-full p-4 flex relative items-center zt-hover">
            <span class="text-left">{{ option.replace('Group', 'Grupa') }}</span>
          </div>
          <hr v-if="options.length -1 !== index" class="w-full border-zt-light">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'SuperbetsSelectMobile',
	emits: ['changedOption', 'closeModal'],
	props: {
		options: Array,
		selectedOption: {
      required: true,
    },
    title: {
      type: String,
      default: 'Opcje',
    },
	},
	methods: {
		handleOptionClick(option) {
			this.$emit('changedOption', option);
		},
	}
}
</script>

<style scoped>
.option {
	@apply after:block after:bg-zt-red after:absolute after:w-1 after:h-10 after:top-1/2 after:left-0
	after:-translate-y-1/2 after:rounded after:opacity-0 after:transition-opacity
}
.selected {
	@apply after:block after:bg-zt-red after:absolute after:w-1 after:h-10 after:top-1/2 after:left-0
	after:-translate-y-1/2 after:rounded after:transition-opacity
	after:opacity-100 bg-[#313E50];
}
</style>